import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Record } from '../model/record';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { ConditionalExpr } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class RecordsService {

  public host: string = 'http://trad.fondation.org.ma:8090';
  public data: Subject<Record> = new Subject<Record>();
  public term: string = '%20';
  public type: string = 'all';
  public size = 8;
  public advanced: String = 'false';
  public filter: String = 'false';

  public titre:string = '';
  public titre_par:string = '';
  public auteur:string = '';
  public sexe:string = '';
  public nat:string = '';
  public desc:string = '';
  public pays_org:string = '';
  public mention_res:string = '';
  public langsource:string = '';
  public langcible:string = '';
  public theme:string = '';
  public themeg:string = '';
  public first:string = '';
  public end:string = '';
  public nbtout:number = 0;
  public local:string;
  public shs:boolean = true;
  public lmg:boolean = false;
  // public nbfara = '';
  // public nbtara = '';

  constructor(private httpClient: HttpClient) {
   }

  public getRecords(page: number) 
  {
    this.advanced = 'false';
    this.term = (this.term=='') ? '%20' : this.term;
    //this.term = '';
    //this.type = '';
    // console.log(this.host + '/api/records/' + this.type  + '/' + this.shs +  '/' + this.lmg +  '?page=' + page + '&size=' + this.size + 'sort=title');
    
    this.httpClient.get(this.host + '/api/records/' + this.type  + '/' + this.shs +  '/' + this.lmg +  '?page=' + page + '&size=' + this.size + 'sort=title')
    .subscribe(res => this.data.next(<Record> res));

    this.httpClient.get(this.host + '/api/nbrecords/all').subscribe(res => { this.nbtout = parseInt(JSON.stringify(res))});
    // this.httpClient.get(this.host + '/api/nbrecords/fromara')
    // .subscribe(res => { this.nbfara = JSON.stringify(res)});
    // this.httpClient.get(this.host + '/api/nbrecords/toara')
    // .subscribe(res => { this.nbtara = JSON.stringify(res)});
  }

  public getRecordsBylink(term: string, type: string, page: number)
  {
    this.advanced = 'false';
    
    this.term = (term=='') ? '%20' : term;
    //console.log(this.host + '/api/find?type=' + this.type + '&term=' + this.term + '&page=' + page + '&size=' + this.size + 'sort=title');
    this.httpClient.get(this.host + '/api/find/' + this.type + '/' + this.term + '/' + this.shs + '/' + this.lmg + '?page=' + page + '&size=' + this.size + 'sort=title')
    .subscribe(res => this.data.next(<Record> res));
  }

  public getRecordsByterm(term: string, type: string, page: number)
  {

    
    this.term = (term=='') ? '%20' : term;
    this.type = type;
    if(this.advanced==='true') {
      // console.log(this.host + '/api/advanced/' + this.titre + '/' + this.titre_par + '/' + this.auteur + '/' + this.desc + '/' + this.pays_org + 
      // '/' + this.mention_res + '/' + this.first + '/' + this.end + '/' + this.langsource + '/' + this.langcible + '/' + this.theme + '/' + this.themeg + '/' + this.sexe + '/' + this.nat + '?page=' + page + '&size=' + this.size + 'sort=title')
      this.httpClient.get(this.host + '/api/advanced/' + this.titre + '/' + this.titre_par + '/' + this.auteur + '/' + this.desc + '/' + this.pays_org + 
      '/' + this.mention_res + '/' + this.first + '/' + this.end + '/' + this.langsource + '/' + this.langcible + '/' + this.theme + '/' + this.themeg + 
      '/' + this.sexe + '/' + this.nat + '/' + this.shs + '/' + this.lmg + '?page=' + page + '&size=' + this.size + 'sort=title')
      .subscribe(res => {
        this.data.next(<Record> res);
        //console.log(this.data['data']);
      });
    } else {
      // console.log(this.host + '/api/find/' + this.type + '/' + this.term + '?page=' + page + '&size=' + this.size + 'sort=title');
      this.httpClient.get(this.host + '/api/find/' + this.type + '/' + this.term + '/' + this.shs + '/' + this.lmg + '?page=' + page + '&size=' + this.size + 'sort=title')
      .subscribe(res => {
        this.data.next(<Record> res);
        //console.log(this.data['data']);
      });
      
    }
  }

  public getRecordsBypage(page: number)
  {
    
    this.term = (this.term=='') ? '%20' : this.term;
    if(this.advanced==='true') {
      this.httpClient.get(this.host + '/api/advanced/' + this.titre + '/' + this.titre_par + '/' + this.auteur + '/' + this.desc + '/' + this.pays_org + 
      '/' + this.mention_res + '/' + this.first + '/' + this.end + '/' + this.langsource + '/' + this.langcible + '/' + this.theme + '/' + this.themeg + 
      '/' + this.sexe + '/' + this.nat + '/' + this.shs + '/' + this.lmg + '?page=' + page + '&size=' + this.size + 'sort=title')
        .subscribe(res => this.data.next(<Record> res));
    } else {
      if(this.term != '' && this.type !='')
      {
        //console.log(this.type);
        this.httpClient.get(this.host + '/api/find/' + this.type  + '/' + this.term + '/' + this.shs + '/' + this.lmg  + '?page=' + page + '&size=' + this.size + 'sort=title')
        .subscribe(res => this.data.next(<Record> res));
      } else {
        //console.log(this.host + 'api/records?page=' + page + '&size=' + this.size + 'sort=title');
        this.httpClient.get(this.host + '/api/records?page=' + page + '&size=' + this.size + 'sort=title')
        .subscribe(res => this.data.next(<Record> res));
      }
    }
  }

  public getFilters(link: string)
  {
    //console.log(link+'/'+this.type);
    return this.httpClient.get(link);
  }

  public getlocal(){
    return this.httpClient.get(this.host + '/api/iplocale');
  }

  public getData(){
    return this.data; 
  }
  public getType(){
    return this.type; 
  }

  changeTypDoc(typD: string) {
    this.data.subscribe(r => {
      console.log(r);
    });
  }

}
